import { defineMessages } from 'react-intl';

const popularWithListenersMessages = defineMessages({
    popularSectionHeadline: {
        id: 'popularSectionHeadline',
        defaultMessage: 'Popular with Listeners of',
        description:
            'Section headline that precedes the content title for the "Popular with Listeners" section',
    },
});

export default popularWithListenersMessages;
